import { Injectable } from "@angular/core";
import { RestService } from "../../services/rest.service";
import { AccountType } from "@qid/core";
import { AccountShareQuery } from "./interface/account-share-query.interface";
import { AccountShare } from "./interface/account-share.interface";

@Injectable({
  providedIn: 'root'
})
export class AccountShareApi {
  static readonly ApiEndpoint = "account-share/";

  constructor(private restService: RestService) {
  }

  async readAll(account_id: string, accountType: AccountType, query: AccountShareQuery = { page: 1 }) {

    return (
      await this.restService.send<any>({
        url: AccountShareApi.ApiEndpoint,
        method: 'GET',
        query: query,
        account_id: account_id,
        accountType: accountType
      })
    ).data;
  }

  async findOpenShareByTemplateId(templateId: string, orgId: string) {
    return (
      await this.restService.send<AccountShare[]>({
        url: AccountShareApi.ApiEndpoint + 'status-open',
        method: 'GET',
        query: {
          templateId,
          orgId,
        }
      })
    ).data;
  }

}
